__webpack_require__.p = "https://cdn.jsdelivr.net/gh/terresolide/formater-metadata-vjs@8.4.6/dist/";